import { getEventSemantics } from "features/VehicleSidebar/AffectedTrains/utils/utils";
import { FC } from "react";
import { DropsBadge, HStack, tokens } from "shared/components/Spor";

type EventBadgesProps = {
  eventType: string;
  eventLabel: string;
  state: string;
};

export const EventBadges: FC<EventBadgesProps> = ({
  eventType,
  eventLabel,
  state,
}) => {
  const labelSemantic = getEventSemantics(eventType);

  const isClosed = state === "CLOSED";
  return (
    <HStack>
      <DropsBadge
        minHeight={tokens.default.size.spacing[4]}
        semantics={isClosed ? "transparent" : labelSemantic}
      >
        {eventLabel}
      </DropsBadge>
      {isClosed && (
        <DropsBadge height={tokens.default.size.spacing[4]} semantics="success">
          Friskmeldt
        </DropsBadge>
      )}
    </HStack>
  );
};
